import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})

export class ArticleService {
    constructor(private _http: HttpClient) { }
    cmsUrl = environment.baseUrl;

    Categories(){
        return this._http.get(this.cmsUrl+'/public-cms/Categories');
    }

    AllArticles(){
        return this._http.get(this.cmsUrl+'/public-cms/AllArticles');
    }

    ArticleBySlug(slug:any){
        const params = new HttpParams().set('slug', slug);
        return  this._http.get(this.cmsUrl + '/public-cms/GetArticleBySlug',{params});
      }
}
